import React from 'react';

const Discount = ({ amount, initialAmount, discountType, bookingCode }) => (
  <div>
    <div style={{ textTransform: 'uppercase', lineHeight: '32px', fontSize: '12px' }}>
      {bookingCode ? `booking code: ${bookingCode}` : ''}
    </div>
    <div
      style={{
        fontSize: '12px',
        height: '20px',
        lineHeight: '20px',
        backgroundColor: '#f5f5f5',
      }}
    >
    <span style={{ display: 'inline-block', marginLeft: '3%', width: '40%' }}>
      {'OFFER RATE'}
    </span>
    <span style={{ display: 'inline-block', color: initialAmount && initialAmount !== amount ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '15%', width: '30%', textAlign: 'center' }}>
      {`${discountType === 'flatRate' ? '$' : ''}${amount || 0}${discountType === 'percentage' ? '%' : ''} OFF`}
    </span>
    </div>
  </div>
);

export default Discount;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/single-product/rates-table/discount.jsx